export default getExportNames;

function getExportNames(exports) {
	var result = {};

	exports.forEach(function (x) {
		if (x.isDefault) return;

		if (x.hasDeclaration) {
			result[x.name] = x.name;
			return;
		}

		x.specifiers.forEach(function (s) {
			result[s.name] = s.as;
		});
	});

	return result;
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/standalone/builders/strictMode/utils/getExportNames.js.01-babel.map